import { Selector } from 'model/State';

const EMAIL_REGEXP = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;

export const selectIsEmailValid: Selector<boolean> = (state) =>
  !state.addon || state.addon.search.email === null || EMAIL_REGEXP.test(state.addon.search.email);

export const selectIsSenValid: Selector<boolean> = (state) =>
  !state.addon || state.addon.search.sen === null || state.addon.search.sen.length > 0;
